// CardList2.js
import React from "react";
import "./css/CardList2.css";
import JobCarousel from "./JobCarousel";

const jobPositions = [
  { title: "Front-End Developer", image: "/image 9.png" },
  {
    title: "Back-End Developer",
    image: "image 10.png",
  },
  {
    title: "AI/ML",
    image: "image 11.png",
  },
  {
    title: "Data Analyst",
    image: "image 12.png",
  },
];

const CardList2 = () => {
  return (
    // <div className="card-list">
    //   {jobPositions.map((job, index) => (
    //     <div key={index} className="card-item">
    //       {" "}
    //       {/* Corrected div closing */}
    //       <div className="card2">
    //         <img src={job.image} alt={job.title} className="card-image" />
    //         <h3 className="card-title">{job.title}</h3>
    //         <p className="card-details">Other details</p>
    //         <button
    //           className="apply-button"
    //           onClick={() =>
    //             window.open(
    //               "https://docs.google.com/forms/d/e/1FAIpQLScDT6gM0C1Kw5IR8VpMCtUPE6J7zaRpTyqmvMdRvdHHGd909w/viewform",
    //               "_blank"
    //             )
    //           }
    //         >
    //           APPLY
    //         </button>
    //       </div>
    //     </div>
    //   ))}
    // </div>
    <div>
      <JobCarousel jobPositions={jobPositions} />
    </div>
  );
};

export default CardList2;
